import { useParams } from "react-router-dom";
import { useApolloClient } from "@apollo/client";

import { useAuthContext } from "../../auth/AuthContext";
import { MemberDocumentsPage } from "./MemberDocumentsPage";

/**
 * Thin page wrapper for PP-searched members. Reads companyId and mpi from
 * route params (URL-encoded), gets userId from auth context, and delegates
 * rendering to MemberDocumentsPage via explicit props (skipping the
 * MEMBER_BY_ID self-fetch that would 401 for PP-only members).
 *
 * Route: /pp-documents/:companyId/:mpi
 */
export default function ProviderPortalDocumentsPage() {
  const { companyId: encodedCompanyId, mpi: encodedMpi } = useParams<{
    companyId: string;
    mpi: string;
  }>();
  const { accountLabel } = useAuthContext();
  // Keep Apollo client in scope so MemberDocumentsPage can call useApolloClient()
  useApolloClient();

  const companyId = encodedCompanyId ? decodeURIComponent(encodedCompanyId) : "";
  const mpi = encodedMpi ? decodeURIComponent(encodedMpi) : "";
  const userId = accountLabel ?? "";

  if (!companyId || !mpi) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
        Member not found.
      </div>
    );
  }

  return (
    <MemberDocumentsPage
      companyId={companyId}
      membMpiNo={mpi}
      userId={userId}
    />
  );
}
